enum MallType {
  Goods = 'A',
  SERVER = 'C',
}

export default MallType;
